module.exports = __webpack_public_path__ + "static/media/sort-up-solid.50a9a8d6.svg";